import React, { useContext, forwardRef } from 'react';
import Type from 'prop-types';
import cn from 'classnames';
import { Typography } from "@mui/material";
import ListContext from '../List/ListContext';
import styles from './ListItemText.module.css';

const ListItemText = forwardRef(function ListItemText(props, ref) {
  const {
    children,
    className,
    disableTypography = false,
    inset = false,
    primary: primaryProp,
    primaryTypographyProps,
    secondary: secondaryProp,
    secondaryTypographyProps,
    ...other
  } = props;
  const { dense } = useContext(ListContext);

  let primary = primaryProp != null ? primaryProp : children;
  if (primary != null && primary.type !== Typography && !disableTypography) {
    primary = (
      <Typography
        variant={dense ? 'body2' : 'body1'}
        className={styles.primary}
        component="span"
        display="block"
        {...primaryTypographyProps}
      >
        {primary}
      </Typography>
    );
  }

  let secondary = secondaryProp;
  if (secondary != null && secondary.type !== Typography && !disableTypography) {
    secondary = (
      <Typography
        variant="body2"
        className={styles.secondary}
        color="textSecondary"
        display="block"
        {...secondaryTypographyProps}
      >
        {secondary}
      </Typography>
    );
  }

  return (
    <div
      className={cn(
        styles.root,
        {
          [styles.dense]: dense,
          [styles.inset]: inset,
          [styles.multiline]: primary && secondary,
        },
        className,
      )}
      ref={ref}
      {...other}
    >
      {primary}
      {secondary}
    </div>
  );
});

/* eslint-disable */
ListItemText.propTypes = {
  children: Type.node,
  className: Type.string,
  disableTypography: Type.bool,
  inset: Type.bool,
  primary: Type.node,
  primaryTypographyProps: Type.object,
  secondary: Type.node,
  secondaryTypographyProps: Type.object,
};
/* eslint-enable */

export default ListItemText;
